import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth';
import { Loader2, AlertCircle, CheckCircle, Lock } from 'lucide-react';
const NovaSenhaPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);
  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      setError('Token não encontrado. Verifique o link recebido por email.');
    }
  }, [token]);
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    // Validação de senha
    if (newPassword.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('As senhas não conferem');
      return;
    }
    setIsLoading(true);
    try {
      await authService.resetPassword(token, newPassword);
      setSuccess(true);
      // Redirect to login after success
      setTimeout(() => {
        navigate('/?showLogin=true');
      }, 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'Erro ao redefinir senha. O token pode ser inválido ou ter expirado.');
    } finally {
      setIsLoading(false);
    }
  };
  if (!tokenValid) {
    return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-1311">
        <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md" data-id="element-1312">
          <div className="flex flex-col items-center justify-center space-y-4" data-id="element-1313">
            <AlertCircle size={48} className="text-red-500" data-id="element-1314" />
            <h1 className="text-2xl font-bold text-center" data-id="element-1315">Link Inválido</h1>
            <p className="text-red-600 text-center font-medium" data-id="element-1316">{error}</p>
            <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1317">
              Voltar para a página inicial
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-1318">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md" data-id="element-1319">
        <h1 className="text-2xl font-bold text-center mb-6" data-id="element-1320">
          Definir Nova Senha
        </h1>
        {success ? <div className="flex flex-col items-center justify-center space-y-4" data-id="element-1321">
            <CheckCircle size={48} className="text-green-500" data-id="element-1322" />
            <p className="text-green-600 text-center font-medium" data-id="element-1323">
              Senha redefinida com sucesso!
            </p>
            <p className="text-gray-500 text-center" data-id="element-1324">
              Você será redirecionado para a página de login em alguns
              segundos...
            </p>
          </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1325">
            {error && <div className="p-3 bg-red-50 text-red-700 rounded-md" data-id="element-1326">
                {error}
              </div>}
            <div data-id="element-1327">
              <label htmlFor="newPassword" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-1328">
                Nova senha
              </label>
              <div className="relative" data-id="element-1329">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1330" />
                <input type="password" id="newPassword" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} minLength={6} autoComplete="new-password" data-id="element-1331" />
              </div>
              <p className="mt-1 text-xs text-gray-500" data-id="element-1332">
                Mínimo de 6 caracteres
              </p>
            </div>
            <div data-id="element-1333">
              <label htmlFor="confirmPassword" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-1334">
                Confirmar nova senha
              </label>
              <div className="relative" data-id="element-1335">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1336" />
                <input type="password" id="confirmPassword" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} minLength={6} autoComplete="new-password" data-id="element-1337" />
              </div>
            </div>
            <button type="submit" className="w-full py-2 mt-6 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-1338">
              {isLoading ? <>
                  <Loader2 size={18} className="mr-2 animate-spin" data-id="element-1339" />
                  Processando...
                </> : 'Redefinir senha'}
            </button>
          </form>}
      </div>
    </div>;
};
export default NovaSenhaPage;